const Translit = str => {
  const L = {
    а: "a",
    б: "b",
    в: "v",
    г: "g",
    д: "d",
    е: "e",
    ё: "e",
    ж: "zh",
    з: "z",
    и: "i",
    й: "y",
    к: "k",
    л: "l",
    м: "m",
    н: "n",
    о: "o",
    п: "p",
    р: "r",
    с: "s",
    т: "t",
    у: "u",
    ф: "f",
    х: "h",
    ц: "c",
    ч: "ch",
    ш: "sh",
    щ: "sch",
    ь: "",
    ы: "y",
    ъ: "",
    э: "e",
    ю: "yu",
    я: "ya"
  };

  return str
    .toLowerCase()
    .split("")
    .map(function(char) {
      if (Object.prototype.hasOwnProperty.call(L, char)) return L[char];
      if (char.match(/[a-z]/)) return char;
      if (char.match(/\d/)) return char;
      return "-";
    })
    .join("")
    .replace(/-+/g, "-")
    .replace(/-$/, "")
    .replace(/^-/, "");
};

export default Translit;
